import * as Sentry from '@sentry/react';

export const setupSentry = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
      environment: import.meta.env.MODE
    });
  }
};
